import { Vue, Component } from 'vue-property-decorator'
import ProductFixed from '~/components/page/product/ProductFixed'
import SectionHelper from '~/utils/sectionHelper'
import s from '~/utils/s'
import LinkItem from '~/types/LinkItem'
import NavBackLink from '~/components/element/NavBackLink'

@Component
export default class ReviewsHeader extends Vue {
  isShowFixedInfo: boolean = false

  get productLink (): LinkItem {
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)
    const { sectionId, id } = s(this.$store).productPage

    return {
      title: 'К описанию товара',
      location: helper.getProductLink(sectionId?.length ? sectionId[0] : s(this.$store).categoryPage.category.id, id) // TODO: добавить seoUrl
    }
  }

  mounted () {
    window.addEventListener('scroll', this.fixedInfoHandler)
    window.addEventListener('resize', this.fixedInfoHandler)
    this.fixedInfoHandler()
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.fixedInfoHandler)
    window.removeEventListener('resize', this.fixedInfoHandler)
  }

  fixedInfoHandler () {
    this.isShowFixedInfo = window.scrollY > 250
  }

  renderFixedHeader () {
    return (
      <transition name="product-page__fixed-slide-fade">
        { this.isShowFixedInfo &&
          <div class="product-page__fixed">
            <ProductFixed {...{
              props: {
                backLink: this.productLink
              }
            }} />
          </div>
        }
      </transition>
    )
  }

  renderHeader () {
    return (
      <div class="reviews-page__product-row">
        <ProductFixed {...{
          props: {
            backLink: this.productLink
          }
        }} />
      </div>
    )
  }

  renderDesktopHeader () {
    return (
      <div class="reviews-page__desktop">
        { this.renderFixedHeader()}
        { this.renderHeader() }
      </div>
    )
  }

  renderMobileHeader () {
    const { title } = s(this.$store).productPage

    return (
      <div class="reviews-page__mobile">
        <NavBackLink {...{
          props: {
            link: this.productLink
          }
        }} />

        <h1 class="reviews-page__title reviews-page__title_mobile">
          Отзывы на { title }
        </h1>
      </div>
    )
  }

  render () {
    return (
      <div>
        { this.renderDesktopHeader() }
        { this.renderMobileHeader() }
      </div>
    )
  }
}
